import { render, staticRenderFns } from "./ordonnance_view.vue?vue&type=template&id=6215ee4c&scoped=true&"
import script from "./ordonnance_view.vue?vue&type=script&lang=js&"
export * from "./ordonnance_view.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance_view.vue?vue&type=style&index=0&id=6215ee4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215ee4c",
  null
  
)

export default component.exports